import {
  demoProductImageUrl,
  displayProductLabel,
  getDemoModelsForRightPanel,
} from "../utils/demoProductLabels.js";

export default function DemoProductThumbnails({ selectedItemName, sopData }) {
  const skus = getDemoModelsForRightPanel(selectedItemName, sopData).filter(
    (sku) => demoProductImageUrl(sku)
  );
  if (skus.length === 0) return null;

  return (
    <div
      data-testid="demo-product-thumbnails"
      className="flex flex-wrap items-center gap-3 px-1 pb-3 border-b border-zinc-200/90 mb-2"
      style={{ fontFamily: "'IBM Plex Sans', sans-serif" }}
    >
      {skus.map((sku) => {
        const src = demoProductImageUrl(sku);
        const label = displayProductLabel(sku);
        return (
          <div key={sku} className="flex items-center gap-2 min-w-0">
            <img
              src={src}
              alt={label}
              width={48}
              height={48}
              loading="lazy"
              decoding="async"
              className="rounded-md object-cover border border-zinc-200 bg-zinc-50 shrink-0"
              style={{ width: 48, height: 48 }}
            />
            <span
              className="text-xs font-medium text-zinc-800 truncate max-w-[10rem] sm:max-w-[14rem]"
              title={label}
            >
              {label}
            </span>
          </div>
        );
      })}
    </div>
  );
}
